<div class="options">
  <div class="options__auth">
    <img
      src="https://cdn.mango-soft.com/mango-core/icon-google-authenticator.svg"
      class="options__auth__icon"
    />
    <span>Google Authentication</span>
  </div>
  <div class="options__auth">
    <img
      src="https://cdn.mango-soft.com/mango-core/icon-microsoft-authenticator.svg"
      class="options__auth__icon"
    />
    <span>Microsoft Authentication</span>
  </div>
  <div class="options__auth">
    <img
      src="https://cdn.mango-soft.com/mango-core/icon-twilio-authenticator.svg"
      class="options__auth__icon"
    />
    <span>Twilio Authentication</span>
  </div>
</div>
